var React = require('react');

function Sms (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.7 2.6c0-.7.6-1.3 1.2-1.3h16c.7 0 1.3.6 1.3 1.3v11c0 .6-.6 1.2-1.3 1.2h-4.8c-.6 0-1.1.2-1.6.5l-5.4 3.6c-.2.1-.4 0-.4-.2v-1.1c0-1.6-1.2-2.8-2.8-2.8H3c-.6 0-1.2-.6-1.2-1.2v-11Z","stroke":"#313131","strokeWidth":"1.5","strokeLinejoin":"round"}));
}

Sms.defaultProps = {"width":"21","height":"20","fill":"none"};

module.exports = Sms;

Sms.default = Sms;
